import * as React from 'react';
import { LoginHeaderGovAU } from './loginHeaderGovAU';
import { LoginHeaderService } from './loginHeaderService';

export const LoginHeader = () => (
    <header>
        <div className='globalRibbon' data-testid='main-header'>
            <LoginHeaderGovAU />
            <LoginHeaderService />
        </div>
    </header>
);
